// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-pass-wrap {
  margin-bottom: 80px;
}
.change-pass-wrap mat-form-field {
  margin-bottom: 8px;
}
.change-pass-header {
  padding: 18px 0px 18px 22px;
  background-color: #fff;
  display: flex;
  gap: 20px;
  border-radius: 14px;
  border: 3px solid #FFF;
  box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.1);
  margin-block: 20px;
}
.change-pass-back-btn {
  display: flex;
  align-items: center;
}
.change-pass-text {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
}
.change-pass-form-body {
  padding: 42px 22px 42px 22px;
  background-color: #fff;
  border-radius: 14px;
  border: 3px solid #FFF;
  box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.1);
}
.change-pass-form-body .mat-mdc-form-field {
  width: 100%;
}
.change-pass-form-body mat-icon .eye-icon {
  margin-right: 15px;
}
.change-pass-form-body .form-field .btn-primary {
  padding-inline: 40px;
  padding-block: 10px;
}

.change-pass-text {
  display: flex;
  align-items: center;
}

.update-password-required {
  font-size: 12px;
  margin-left: auto;
  margin-bottom: 0;
  margin-right: 18px;
  color: var(--danger-color);
  font-weight: 500;
}

.info_wrapper .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix {
  background: #ccc;
}
.info_wrapper .email_id,
.info_wrapper .name {
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-color);
}
.info_wrapper .email_id .strong,
.info_wrapper .name .strong {
  display: block;
  font-weight: 300;
  margin-bottom: 0;
  line-height: 1.2;
  color: var(--content-color);
}
.info_wrapper .email_id {
  text-align: right;
}

.password-validation-list {
  margin: 10px 0;
  padding: 10px;
  border-radius: 4px;
  background-color: #f5f5f5;
}
.password-validation-list .validation-item {
  display: flex;
  align-items: center;
  margin: 5px 0;
  color: #ff0000;
  font-size: 14px;
  transition: color 0.3s ease;
}
.password-validation-list .validation-item.valid {
  color: #00c853;
}
.password-validation-list .validation-item .validation-icon {
  margin-right: 8px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/change-password/change-password.component.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;AADR;AAGQ;EACI,kBAAA;AADZ;AAKI;EACI,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,qDAAA;EACA,kBAAA;AAHR;AAMI;EACI,aAAA;EACA,mBAAA;AAJR;AAOI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AALR;AAQI;EACI,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qDAAA;AANR;AAQQ;EACI,WAAA;AANZ;AASQ;EACI,kBAAA;AAPZ;AAUQ;EACI,oBAAA;EACA,mBAAA;AARZ;;AAcA;EACI,aAAA;EACA,mBAAA;AAXJ;;AAcA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AAXJ;;AAiBI;EACI,gBAAA;AAdR;AAgBI;;EAEI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAdR;AAeQ;;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;AAZZ;AAeI;EACI,iBAAA;AAbR;;AAiBA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAdF;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AAdJ;AAgBI;EACE,cAAA;AAdN;AAiBI;EACE,iBAAA;EACA,iBAAA;AAfN","sourcesContent":[".change-pass {\n\n    &-wrap {\n        margin-bottom: 80px;\n\n        mat-form-field {\n            margin-bottom: 8px;\n        }\n    }\n\n    &-header {\n        padding: 18px 0px 18px 22px;\n        background-color: #fff;\n        display: flex;\n        gap: 20px;\n        border-radius: 14px;\n        border: 3px solid #FFF;\n        box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.10);\n        margin-block: 20px;\n    }\n\n    &-back-btn {\n        display: flex;\n        align-items: center;\n    }\n\n    &-text {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n    }\n\n    &-form-body {\n        padding: 42px 22px 42px 22px;\n        background-color: #fff;\n        border-radius: 14px;\n        border: 3px solid #FFF;\n        box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.10);\n\n        .mat-mdc-form-field {\n            width: 100%;\n        }\n\n        mat-icon .eye-icon {\n            margin-right: 15px;\n        }\n\n        .form-field .btn-primary {\n            padding-inline: 40px;\n            padding-block: 10px;\n        }\n\n    }\n}\n\n.change-pass-text {\n    display: flex;\n    align-items: center;\n}\n\n.update-password-required {\n    font-size: 12px;\n    margin-left: auto;\n    margin-bottom: 0;\n    margin-right: 18px;\n    color: var(--danger-color);\n    font-weight: 500;\n}\n\n.info_wrapper {\n    // display: flex;\n    // justify-content: space-between;\n    .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{\n        background: #ccc;\n    }\n    .email_id,\n    .name {\n        margin-bottom: 15px;\n        font-size: 14px;\n        font-weight: 500;\n        color: var(--primary-color);\n        .strong {\n            display: block;\n            font-weight: 300;\n            margin-bottom: 0;\n            line-height: 1.2;\n            color: var(--content-color);\n        }\n    }\n    .email_id{\n        text-align: right;\n    }\n}\n\n.password-validation-list {\n  margin: 10px 0;\n  padding: 10px;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n\n  .validation-item {\n    display: flex;\n    align-items: center;\n    margin: 5px 0;\n    color: #ff0000;\n    font-size: 14px;\n    transition: color 0.3s ease;\n\n    &.valid {\n      color: #00c853;\n    }\n\n    .validation-icon {\n      margin-right: 8px;\n      font-weight: bold;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
